import { render } from "./Error.vue?vue&type=template&id=026a7a08"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "026a7a08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('026a7a08', __exports__)) {
    api.reload('026a7a08', __exports__)
  }
  
  module.hot.accept("./Error.vue?vue&type=template&id=026a7a08", () => {
    api.rerender('026a7a08', render)
  })

}


export default __exports__